"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderAssembleGrid = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var HeaderAssembleGrid = _styledComponents["default"].div.withConfig({
  displayName: "style__HeaderAssembleGrid",
  componentId: "idpygt-0"
})(["display:flex;width:100%;height:auto;background-color:#131823;color:white;"]); //   padding: 5px;


exports.HeaderAssembleGrid = HeaderAssembleGrid;